// @flow
import { useCallback } from 'react';
import classnames from 'classnames';

import FilterSection from '../catalogFilters/FilterSection';
import FilterTab from '../catalogFilters/FilterTab';
import FilterCheckItem from '../catalogFilters/FilterCheckItem';
import FilterItems from '../catalogFilters/FilterCheckItems';

import QuestionMarkPopup from '../popups/QuestionMark';
import * as SolitaireContent from '../popups/content/Solitaire';
import * as HaloContent from '../popups/content/Halo';
import * as ThreeStoneContent from '../popups/content/ThreeStone';
import * as DiamondAccentContent from '../popups/content/DiamondAccent';
import * as DiamondPaveContent from '../popups/content/DiamondPave';

import css from '@styles/ringFilters';

type TProps = {
  isOpen: boolean,
  onToggle: () => void,
  onFilterCheckToggle: (Category: string, Value: string) => void,
  isOpen: boolean,
  onToggle: () => void,
  selectedItems: Array<string>
};

function itemIsSelected(selectedItems, item) {
  return selectedItems.indexOf(item) >= 0;
}

export default function StyleFilters({
  onFilterCheckToggle,
  selectedItems,
  isOpen,
  onToggle
}: TProps) {
  const handleCheckToggle = useCallback(e => {
    onFilterCheckToggle('style', e.currentTarget.value);
  }, []);

  return (
    <FilterSection
      className={css.style}
      enableClickOutside={isOpen}
      onClickOutside={onToggle}
    >
      <FilterTab
        name='Style'
        className={classnames(css.styleTab)}
        showingContent={isOpen}
        activeFilterCount={selectedItems.length}
        onClick={onToggle}
        key='style-tab'
      />
      <FilterItems
        className={css.styleContent}
        show={isOpen}
        key='style-content'
      >
        <FilterCheckItem
          label='Solitaire'
          inputValue='Solitaire'
          htmlId='style-solitaire'
          popup={({ className }) => (
            <QuestionMarkPopup
              initialContent={SolitaireContent}
              className={className}
              doNotScrollToPopup
            />
          )}
          selected={itemIsSelected(selectedItems, 'Solitaire')}
          onChange={handleCheckToggle}
        />
        <FilterCheckItem
          label='Halo'
          inputValue='Halo'
          htmlId='style-halo'
          popup={({ className }) => (
            <QuestionMarkPopup
              initialContent={HaloContent}
              className={className}
              doNotScrollToPopup
            />
          )}
          selected={itemIsSelected(selectedItems, 'Halo')}
          onChange={handleCheckToggle}
        />
        <FilterCheckItem
          label='3 Stone'
          inputValue='3-Stone'
          htmlId='style-3-stone'
          popup={({ className }) => (
            <QuestionMarkPopup
              initialContent={ThreeStoneContent}
              className={className}
              doNotScrollToPopup
            />
          )}
          selected={itemIsSelected(selectedItems, '3-Stone')}
          onChange={handleCheckToggle}
        />
        <FilterCheckItem
          label='Diamond Accent'
          inputValue='Diamond Accent'
          htmlId='style-diamond-accent'
          popup={({ className }) => (
            <QuestionMarkPopup
              initialContent={DiamondAccentContent}
              className={className}
              doNotScrollToPopup
            />
          )}
          selected={itemIsSelected(selectedItems, 'Diamond Accent')}
          onChange={handleCheckToggle}
        />
        <FilterCheckItem
          label='Diamond Pave'
          inputValue='Pave'
          htmlId='style-pave'
          popup={({ className }) => (
            <QuestionMarkPopup
              initialContent={DiamondPaveContent}
              className={className}
              doNotScrollToPopup
            />
          )}
          selected={itemIsSelected(selectedItems, 'Pave')}
          onChange={handleCheckToggle}
        />
      </FilterItems>
    </FilterSection>
  );
}
